import { appUrlJump } from '@/utils/utils';

export const needSelectServiceNumber = (claimDetail, chooseSubNumMethod) => {
  const { telcoFlag } = claimDetail || {};
  return telcoFlag === 'Y' && ['66', '67'].includes(chooseSubNumMethod);
};

export const shouldClaimDirectly = (claimDetail, chooseSubNumMethod) => {
  const { telcoFlag } = claimDetail || {};
  return telcoFlag !== 'Y' || chooseSubNumMethod === '65' || !chooseSubNumMethod;
};

export const buildSubscriberQuery = subNumType => {
  const params = {
    includesVirtualSubs: false,
  };

  if (subNumType === '2') {
    params.paidFlags = 0;
  }
  if (subNumType === '3') {
    params.paidFlags = 1;
  }

  return params;
};

export const handleClaimRewardPopupAction = (pageRenderDetail, closePopup) => {
  const {
    claimRewardPopupButtonAction,
    claimRePopBuUrlSelectLinkType,
    claimRePopBuUrlLinkType,
    claimRePopBuUrlSelectValue,
    claimRePopBuUrlInput,
  } = pageRenderDetail || {};
  const keyNum = claimRePopBuUrlSelectLinkType || claimRePopBuUrlLinkType;
  const link = claimRePopBuUrlSelectValue || claimRePopBuUrlInput;

  if (claimRewardPopupButtonAction === '1') {
    closePopup();
  } else if (claimRewardPopupButtonAction === '2') {
    if (Number(keyNum) === 2) appUrlJump(link);
    if (Number(keyNum) === 3 || Number(keyNum) === 1) appUrlJump(link, true);
  }
};
